var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5464 29.75C14.7951 30.1807 15.1527 30.5383 15.5834 30.787C16.0142 31.0356 16.5027 31.1665 17.0001 31.1665C17.4974 31.1665 17.986 31.0356 18.4167 30.787C18.8474 30.5383 19.205 30.1807 19.4537 29.75",
    stroke: "#F66D25",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62111 21.7118C4.43604 21.9147 4.31391 22.1669 4.26957 22.4379C4.22523 22.7089 4.26059 22.9869 4.37136 23.2381C4.48212 23.4894 4.66352 23.703 4.89347 23.8531C5.12342 24.0031 5.39203 24.0831 5.66661 24.0833H28.3333C28.6078 24.0834 28.8765 24.0037 29.1066 23.854C29.3367 23.7042 29.5183 23.4908 29.6294 23.2397C29.7404 22.9886 29.7761 22.7107 29.7321 22.4397C29.6882 22.1687 29.5664 21.9163 29.3816 21.7132C27.4974 19.771 25.4999 17.7069 25.4999 11.3333C25.4999 9.07897 24.6044 6.91696 23.0104 5.32291C21.4163 3.72885 19.2543 2.83331 16.9999 2.83331C14.7456 2.83331 12.5836 3.72885 10.9895 5.32291C9.39548 6.91696 8.49994 9.07897 8.49994 11.3333C8.49994 17.7069 6.50103 19.771 4.62111 21.7118Z",
    stroke: "#F66D25",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.df9f0080e4e6b4bbf7a8e4923feff61e.svg";
export { ForwardRef as ReactComponent };